<template>
  <div class="step1" v-if="content.show">
    <h4>第一步</h4>
    <p>请选择出你最感兴趣的三个毕业方向</p>
    <ul class="direction-box">
      <li v-for="(item,index) in content.options" @click="selectCurrent(item,index)">
      <div class="option-block" :class="['option-back'+index,selected[index]?'option-select':'']"></div>
      <span>{{item}}</span>
      </li>
    </ul>
    <p>已选取毕业方向：<span class="protrude">{{directions.join('、')}}</span><span>{{content.errorMessage}}</span></p>
  </div>
</template>
<script>
export default {
  props:{
    content:Object
  },
  data(){
    return{
      directions:[],
      selected:[false,false,false,false,false,false,false,false,false,false,false,false]
    }
  },
  methods:{
    selectCurrent(name,i){
      if(this.directions.length>0){
        let num = this.directions.indexOf(name)
        // 判断是不是已经被选择,如果已经被选择,再次点击取消，未被选中加入选中行列
        if(num<0){
          if(this.directions.length<3){
            this.$set(this.selected, i, true)
            this.directions.push(name)
            this.content.errorMessage=",还差"+(3-this.directions.length)+"项"
            this.$emit("listenToChildEvent",[],this.content.num)
          }
          if(this.directions.length==3){
            this.content.errorMessage="，已经选够3项"
            this.$emit("listenToChildEvent",this.directions,this.content.num)
          }
        }else{
          this.directions.map((item,index)=>{
            if(item==name){
              this.directions.splice(index,1)
            }
            this.$set(this.selected, i, false)
            this.content.errorMessage=",还差"+(3-this.directions.length)+"项"
            this.$emit("listenToChildEvent",[],this.content.num)
          })
        }
      }else{
        this.directions.push(name)
        this.$set(this.selected, i, true)
        this.content.errorMessage=",还差"+(3-this.directions.length)+"项"
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .step1
    text-align:center
    h4
      font-size:0.32rem
  .direction-box
    overflow:hidden
    li
      float:left
      position:relative
      width:50%
      height:1.8rem
      span
        position: absolute;
        top:0
        left:0
        color:#ffffff
        width:80%
        height:1.2rem
        margin:0.2rem
        font-size:0.36rem
        display: flex;
        display:-webkit-flex;
        justify-content: center;/*水平居中*/
        align-items: center;/*垂直居中*/
        -webkit-align-items:center;
    .option-block
      position:relative
      width:80%
      margin:0.2rem
      height:1.2rem
      background-color:#595959
      opacity:0.5
    .option-back0
      background-color:#8C0061
    .option-back1
      background-color:#F15769
    .option-back2
      background-color:#FAD309
    .option-back3
      background-color:#C1D659
    .option-back4
      background-color:#073095
    .option-back6
      background-color:#BB0031
    .option-back7
      background-color:#F15D07
    .option-back8
      background-color:#0DA896
    .option-back9
      background-color:#79CDE2
    .option-select
      opacity:1
      padding:0.1rem
      margin-top:0.1rem
  .protrude
    color:#DC6E5A
    font-weight:bold
</style>
